import React from "react";
import AppInputField from "../CommonReusableComponent/AppInputField/AppInputField";
import { IconButton } from "@mui/material";
import { Icons } from "../../config/MuiIcons.config";

const MUITableSearch = ({ SearchText, HandleSearch, CancelSearch }) => {
  return (
    <AppInputField
      InputProps={{
        startAdornment: (
          <IconButton className="p-1">
            <Icons.Search end={"start"} />
          </IconButton>
        ),
        endAdornment: (
          SearchText ? (
            <IconButton onClick={CancelSearch} className="p-1">
              <Icons.Clear end={"end"} />
            </IconButton>
          ) : null
        )
      }}
      PlaceHolder={"Search"}
      Size={"small"}
      Value={SearchText}
      OnChange={HandleSearch}
    />
  );
};

export default MUITableSearch;
